import Swiper from 'swiper/dist/js/swiper';
import 'magnific-popup';
import 'jquery.scrollto';
import './ajax';

const $win = $(window);
const $doc = $(document);
const $header = $('.header');
const $ctaSticky = $('.cta-sticky');

var resTablet = $win.width() < 1024;
var resMobile = $win.width() < 768;
$win.on('resize', function () {
	var resTablet = $win.width() < 1024;
	var resMobile = $win.width() < 768;
});


// Polyfill
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function (valueToFind, fromIndex) {

			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			// 1. Let O be ? ToObject(this value).
			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If len is 0, return false.
			if (len === 0) {
				return false;
			}

			// 4. Let n be ? ToInteger(fromIndex).
			//    (If fromIndex is undefined, this step produces the value 0.)
			var n = fromIndex | 0;

			// 5. If n ≥ 0, then
			//  a. Let k be n.
			// 6. Else n < 0,
			//  a. Let k be len + n.
			//  b. If k < 0, let k be 0.
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			function sameValueZero(x, y) {
				return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
			}

			// 7. Repeat, while k < len
			while (k < len) {
				// a. Let elementK be the result of ? Get(O, ! ToString(k)).
				// b. If SameValueZero(valueToFind, elementK) is true, return true.
				if (sameValueZero(o[k], valueToFind)) {
					return true;
				}
				// c. Increase k by 1.
				k++;
			}

			// 8. Return false
			return false;
		}
	});
}

// Sliders
$doc.ready(() => {
    $('body').on('click', '.new-hires__card-read-more', function () {
        console.log('clicked', $(this));
        $(this).closest(".cfm-episode-wrap").children(".card-content--short").toggle();
        $(this).closest(".cfm-episode-wrap").children(".card-content--long").toggle();
    });
});
// Sliders
$doc.ready(() => {

	let timeOut = '';

	const sliderIntroSettings = {
		autoplay: false,
		// autoplay: 0,
		loop: true,
		slidesPerView: 1,
		pagination: {
			el: '.slider-intro .slider__paging',
			clickable: true
		},
		threshold: 20,
		on: {
			init: function (e) {
				if ($(this.slides[this.activeIndex]).find('video')[0] == null) {
				 timeOut = window.setTimeout(() => {
					 	document.querySelector('.slider-intro .swiper-container').swiper.slideNext();
					 }, 4000);
				}
			},
			slideChange: function (e) {
				clearTimeout(timeOut);
				if ($(sliderIntro.slides[sliderIntro.previousIndex]).length > 0) {
					if ($(sliderIntro.slides[sliderIntro.previousIndex]).find('video')[0] != null) {
						$(sliderIntro.slides[sliderIntro.previousIndex]).find('video')[0].currentTime = 0;
						$(sliderIntro.slides[sliderIntro.previousIndex]).find('video')[0].pause();
					}
				}
				if ($(sliderIntro.slides[sliderIntro.activeIndex]).find('video')[0] != null) {
					$(sliderIntro.slides[sliderIntro.activeIndex]).find('video')[0].currentTime = 0;
					$(sliderIntro.slides[sliderIntro.activeIndex]).find('video')[0].play();
				} else {
					timeOut = window.setTimeout(() => {
						document.querySelector('.slider-intro .swiper-container').swiper.slideNext();
					}, 5000);
				}
			}
		}

	}

	const sliderIntro = new Swiper('.slider-intro .swiper-container', sliderIntroSettings);
	//careers page slider
	const swiperGallery = new Swiper('.careers__row--gallery .swiper-container', {
		slidesPerView: 3,
		slidesPerColumn: 3,
		slidesPerGroup: 9,
		spaceBetween: 10,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			1199: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			767: {
				slidesPerView: 1,
				slidesPerGroup: 1,
			}
		}
	});

	// Homepage - video slider
	const swiperVideo = new Swiper('.video-slider .swiper-container', {
		loop: true,
		spaceBetween: 10,
		slidesPerView: 3,
		pagination: {
			el: '.slider__paging-video',
			clickable: true,
		},
		navigation: {
			nextEl: ".swiper-button-next-video",
			prevEl: ".swiper-button-prev-video",
		},
		breakpoints: {
			1280:{
				slidesPerView: 3
			},
			991: {
				slidesPerView: 3
			},
			767: {
				slidesPerView: 1,
				spaceBetween: 0,
				centeredSlides: true,
			}
		}
	});


	let vids = document.querySelectorAll('.slider__video-src');
	for (let i = 0; i < vids.length; i++) {
		vids[i].addEventListener('ended', () => {
			if (i === (vids.length - 1)) {
				document.querySelector('.slider-intro .swiper-container').swiper.slideTo(0);
			}
			else {
				document.querySelector('.slider-intro .swiper-container').swiper.slideNext();
			}
		}, false);
	}

	//end doc ready


});

const sliderFeedSettings = {
	slidesPerView: 4,
	spaceBetween: 37,
	pagination: {
		el: '.slider-feed .slider__paging',
		clickable: true
	},
	touchRatio: 0,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	breakpoints: {
		1199: {
			slidesPerView: 3
		},
		767: {
			slidesPerView: 1
		}
	}
}

const sliderFeed = new Swiper('.slider-feed .swiper-container', sliderFeedSettings);

// Sticky Header

$win.on('scroll', () => {
	const winT = $win.scrollTop();

	$header.toggleClass('header--small', winT >= 50);

	// ( winT >= 250 ) ? $ctaSticky.addClass('visible') : $ctaSticky.removeClass('visible');

	if (resMobile || resTablet) {
		(winT >= $('.section-form').offset().top - $('.section-form').outerHeight())
			? $ctaSticky.removeClass('visible')
			: $ctaSticky.addClass('visible');
	}
});

$doc.ready(function () {
    function EmbedAndPlay_Youtube(videoid, container) {
        $.getScript("//www.youtube.com/iframe_api")
            .fail(function () {
                // some kind of alert to the user ...
            })
            .done(function () {
                window.onYouTubeIframeAPIReady = function () {
                    var $container = $(container);
                    var w = $(container).width(),
                        h = $(container).height(),
                        player = new YT.Player('ytvideo', {
                            height: h,
                            width: w,
                            videoId: videoid,
                            events: {
                                'onReady': function (event) {
                                    event.target.playVideo();
                                }
                            }
                        });
                }
            });
    }

  //BT2 VIDEO SLIDER
	const swiper = new Swiper('#swiper-btk2', {
		// Optional parameters
		loop: true,
		shortSwipes: false,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},


		slidesPerView: 3.0,
		spaceBetween: 40,
		slidesPerGroup: 3,
		breakpoints: {
			// when window width is >= 320px
			1023: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
				shortSwipes: true,
			},
		}

	});

    // TWO VIDEO SLIDER
    const twoVideoSwiper = new Swiper('#swiper-two-col', {
		// Optional parameters
		loop: true,
		shortSwipes: false,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},


		slidesPerView: 2.0,
		spaceBetween: 40,
		slidesPerGroup: 2,
		breakpoints: {
			// when window width is >= 320px
			1023: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
				shortSwipes: true,
			},
		}

	});

  // THREE VIDEO SLIDER
	const threeVideoSwiper = new Swiper('#swiper-three-col', {
		// Optional parameters
		loop: true,
		shortSwipes: false,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},


		slidesPerView: 3.0,
		spaceBetween: 40,
		slidesPerGroup: 3,
		breakpoints: {
			// when window width is >= 320px
			1023: {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 0,
				shortSwipes: true,
			},
		}

	});







	function stopIframe(){
		let width = $win.width();
		$('iframe').each(function(){
			$(this).attr('src', $(this).attr('src'));
			if(width > 1023){
			$(this).siblings('.video-slider-thumbnail').show();

			}

		})
	}




	$('.video-slider-thumbnail').on('click', function(){
		let $this = $(this);
		let $video = $this.siblings('iframe')[0];
		let $videoSrc = $($video).attr('src');
		$this.hide()
		$($video).attr('src', $videoSrc  + '&mute=1&autoplay=1&playsinline=1');


	})



	swiper.on('beforeTransitionStart', function(){
		stopIframe();
	})

});

$('.slider__slide-actions .btn.btn--orange.btn--icon, .btn-video').magnificPopup({
	type: 'inline',
	mainClass: 'popup',
	closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`,
	callbacks: {
		open: function () {
			if (jQuery(this.content).find('#popup-player').length > 0) {

				var src = jQuery('#popup-player').attr('src');
				jQuery('#popup-player').attr('src', src + '&autoplay=1');
			}
			if (jQuery(this.content).find('#popup-player-why').length > 0) {
				var src = jQuery('#popup-player-why').attr('src');
				jQuery('#popup-player-why').attr('src', src + '&autoplay=1');
			}
			if (jQuery(this.content).find('#popup-player-eccentric').length > 0) {
				var src = jQuery('#popup-player-eccentric').attr('src');
				jQuery('#popup-player-eccentric').attr('src', src + '&autoplay=1');
			}
			if (jQuery(this.content).find('#popup-player-c2-animation').length > 0) {
				var src = jQuery('#popup-player-c2-animation').attr('src');
				jQuery('#popup-player-c2-animation').attr('src', src + '&autoplay=1');
			}

		},
		close: function () {
			if (jQuery(this.content).find('#popup-player').length > 0) {
				var src = jQuery('#popup-player').attr('src');
				jQuery('#popup-player').attr('src', src.replace('&autoplay=1'))
			}
			if (jQuery(this.content).find('#popup-player-why').length > 0) {
				var src = jQuery('#popup-player-why').attr('src');
				jQuery('#popup-player-why').attr('src', src.replace('&autoplay=1'))
			}
			if (jQuery(this.content).find('#popup-player-eccentric').length > 0) {
				var src = jQuery('#popup-player-eccentric').attr('src');
				jQuery('#popup-player-eccentric').attr('src', src.replace('&autoplay=1'));
			}
			if (jQuery(this.content).find('#popup-player-c2-animation').length > 0) {
				var src = jQuery('#popup-player-c2-animation').attr('src');
				jQuery('#popup-player-c2-animation').attr('src', src.replace('&autoplay=1'));
			}

		}
	}
});


if ( $(".panel-tabs__tab").length ) {

    $(".panel-tabs__tab").click(function () {

        if ( !$(this).hasClass("is-active") ) {

            $(".panel-tabs__tab.is-active").removeClass("is-active");
            $(this).addClass("is-active");

            let tab_id = $(this).data("tab-id");
            togglePanel(tab_id);
        }
    })

    $(".panel-tabs-mobile__tab").click(function () {
        let active_panel_id = $(".panels__container").attr("data-active-panel-id");
        let this_panel_id = $(this).attr('data-mobile-panel-id');
        console.log(active_panel_id)
        console.log(this_panel_id)

        if (active_panel_id != this_panel_id ) {
            $(".panels__container").attr("data-active-panel-id", this_panel_id);
            togglePanel(this_panel_id);
        }
    })

    function togglePanel(panelIndex) {
        $(".panel-item.is-active").removeClass("is-active");
        $('[data-panel-id="' + panelIndex + '"').addClass("is-active");
    }

    function togglePlay( targetVideo, button) {
        // need to get 0 due to targetVideo being a jquery selector
        let video = targetVideo.get(0);

        // if targetted video is not playing, play it
        if ( video.paused || video.ended ) {

            // pause all other videos
            $(".c2-video").each(function () {
                let thisVideo = $(this).get(0);
                if ( !thisVideo.paused && !video.ended ) {
                    $(this).siblings(".video__play").removeClass('hidden')
                    thisVideo.pause();
                }
            })

            video.play();
            button.addClass('hidden')

            // once video ends, un-hide play button
            video.onended = function () {
                button.removeClass("hidden")
            };

        // if targetted is not playing, stop it
        } else {
            button.removeClass('hidden')
            video.pause();
        }
    }

    // when a play button is clicked, play the video
    $(".video__play").click(function () {
        let video = $(this).siblings(".c2-video");
        togglePlay(video, $(this));
    })

    // when a video is clicked, pause it
    $(".c2-video").click(function () {
        let button = $(this).siblings(".video__play");
        togglePlay($(this), button);
    })

    // for the C6 product page, if the background video exists, make it replay after a loop of 5 seconds.
    let backgroundVideo = document.getElementById("c6BackgroundVideo");

    if (backgroundVideo) {
        backgroundVideo.onended = function () {
            setTimeout(function () {
                backgroundVideo.play();
            }, 5000);
        };
    }
}

$('.valve-popup > a').magnificPopup({
	type: 'inline',
	mainClass: 'popup',
	closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
})

	// $('.cta-sticky a').magnificPopup({
	// 	type: 'inline',
	// 	mainClass: 'popup',
	// 	closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
	// });

	$('.video-popup-m5').magnificPopup({
		type: 'inline',
		mainClass: 'popup m5-plus-popup',
		closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
	});

	$('.video-sterile-sleeve').magnificPopup({
		type: 'inline',
		mainClass: 'popup m5-plus-popup',
		closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
	});

	$('.video-popup').magnificPopup({
		type: 'inline',
		mainClass: 'popup',
		closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
	});

	// $('.m5__play').magnificPopup({
	// type: 'iframe',
	// 	mainClass: 'popup m5-plus-popup',
	// 	closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
	// });


$('.bkt-2__video-row a').magnificPopup({
	// disableOn: 700,
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,

	fixedContentPos: false,
	closeMarkup: `<button title="%title%" type="button" class="mfp-close">X</button>`
});

$doc.on('gform_confirmation_loaded', function (event, formId) {
	if (typeof crb.popup_form !== 'undefined') {
		if (formId == parseInt(crb.popup_form)) {
			$.magnificPopup.close();

			if ($('#form-2').length) {
				$('.cta-sticky a')
					.attr('href', '#form-2')
					.trigger('click');
			}
		}
	}
});

// Hero Popups
if ($('.btn-mfp-close').length > 0) {
	let close = document.querySelectorAll('.btn-mfp-close');
	for (let i = 0; i < close.length; i++) {
		close[i].addEventListener('click', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		})
	}
}
if ($('.loc-us #home-link--coronary, .menu-link--coronary a').length > 0) {
	$('.loc-us #home-link--coronary, .menu-link--coronary a').click(function (e) {
		if (window.localStorage.getItem('home-coronary') != 'true') {
			e.preventDefault();
			window.localStorage.setItem('home-coronary', 'true');
			$.magnificPopup.open({
				items: {
					src: '#coronary-popup',
					type: 'inline'
				}
			});
		} else {
			console.log('hit');
		}
	});
}
// if($('.menu-link--coronary').length > 0 ){
// 	$('.menu-link--coronary').click(function(e){
// 		e.preventDefault();
// 		$.magnificPopup.open({
// 			items: {
// 				src: '#coronary-popup',
// 				type: 'inline'
// 			}
// 		});
// 	});
// }
// if($('#home-link--peripheral').length > 0 ){
//     if($('body').hasClass('loc-us')){
//         $('#home-link--peripheral').click(function(e){
//             e.preventDefault();
//             $.magnificPopup.open({
//                 items: {
//                     src: '#peripheral-popup',
//                     type: 'inline'
//                 }
//             });
//         });
//     }
// }
// if ($('#home-link--valve').length > 0) {
// 	$('#home-link--valve').click(function (e) {
// 		e.preventDefault();
// 		$.magnificPopup.open({
// 			items: {
// 				src: '#valve-form',
// 				type: 'inline'
// 			}
// 		});
// 	});
// }

// GDPR
$doc.ready(function () {
	if (window.localStorage.getItem('swgdpr') == null) {
		$('#section-gdpr').fadeIn();
	}
	$('#gdpr-consent').click(function (e) {
		e.preventDefault();
		window.localStorage.setItem('swgdpr', 1);
		$('#section-gdpr').fadeOut();
	});

})

// Disabled Links
$doc.ready(function () {
	$('.menu-item-marker > a').click(function (e) {
		e.preventDefault();
	})
	$('.disabled-link > a').click(function (e) {
		e.preventDefault();
	})
});

// Nav Dropdowns
$doc.ready(function () {
	if ($win.width() < 1367 || $('body').hasClass('ipad')) {
		$('.nav li').on("click touchend", function (e) {
			e.stopPropagation();
			// console.log(e.target.nodeName);
			let that = $(this);
			if (that.hasClass('menu-item-has-children')) {
				if ($(this).hasClass('nav-item--expanded')) {
					that.siblings().removeClass('nav-item--hidden');
					if (that.parent().parent().hasClass('nav-item--expanded')) {
						that.parent().parent().children('a').slideDown(500);
					}
				} else {
					$(this).siblings().addClass('nav-item--hidden');
					if (that.parent().parent().hasClass('nav-item--expanded')) {
						that.parent().parent().children('a').slideUp(500);
					}
				}
				that.closest('a').toggleClass('nav-item--hidden');
			}
			if (window.innerWidth < 1367) {
				if ($(this).children('.sub-menu').length) {
					e.preventDefault();
					e.stopPropagation();
					const $sub_menu = $(this).children('.sub-menu');

					$(this).toggleClass('nav-item--expanded')
						.siblings().children('.sub-menu').slideUp(500);

					$(this).siblings().removeClass('nav-item--expanded');

					$sub_menu.slideToggle();
				}
			}
		});
	}
})
$win.on('resize', function () {
	if ($win.width() < 1401 || $('body').hasClass('ipad')) {
		// $('.nav li').off();
		// $('.nav li').on("click touchstart", function(e){
		// 	if(window.innerWidth < 1401){
		// 		if ( $(this).children('.sub-menu').length ) {
		// 			e.preventDefault();
		// 			e.stopPropagation();
		// 			const $sub_menu = $(this).children('.sub-menu');
		//
		// 			$(this).toggleClass('nav-item--expanded')
		// 				.siblings().children('.sub-menu').slideUp();
		//
		// 			$(this).siblings().removeClass('nav-item--expanded');
		//
		// 			$sub_menu.slideToggle();
		// 		}
		// 	}
		// });
		$('.sub-menu a').off();
		$('.sub-menu a').on('click touchstart', function (e) {
			if (!$(this).parent().hasClass('submenu-label') && !$(this).parent().hasClass('disabled-link')) {
				e.stopPropagation();
			} else {
				e.preventDefault();
			}
		})
	}
});


// Show main nav
$('.header .btn-nav').on('click', function (event) {
	$(this).toggleClass('active').closest('html').toggleClass('mobile-show');

	event.preventDefault();
});

// World Locations
$doc.ready(function () {
	if ($('.world-map__location').length > 0) {
		$('.world-map__location').click(function () {
			$('.world-map__location.active').not(this).removeClass('active');
			$(this).toggleClass('active');
		})
	}
})

// Accordion
$doc.ready(function () {
	if ($('.spec-table__accordion .toggle').length > 0) {
		$('.spec-table__accordion .toggle').click(function (e) {
			e.preventDefault();

			var $this = $(this);

			if ($this.next().hasClass('show')) {
				$this.next().removeClass('show');
				$this.removeClass('active');
				$this.next().slideUp(350);
			} else {
				$this.parent().parent().find('li .inner').removeClass('show');
				$this.parent().parent().find('li a.toggle').removeClass('active');
				$this.parent().parent().find('li .inner').slideUp(350);
				$this.next().toggleClass('show');
				$this.toggleClass('active');
				$this.next().slideToggle(350);
			}
		});
	}
})

// Rotating Image
$doc.ready(function () {
	if ($('.section--rotating-img-row').length > 0) {
		$('.rotating-img-title').click(function () {
			if ($(this).hasClass('active')) {
				return true;
			}
			$('.rotating-img-slide .rotating-img-markup-item.active').removeClass('active');
			$('.rotating-img-title.active').removeClass('active');
			$(this).addClass('active');
			$('.rotating-img-slide.active').removeClass('active');
			let slide = $(this).data('slide');
			$('.rotating-img-ins').find("[data-slide='" + slide + "']").addClass('active');
			$('#rotating-img-slider')[0].value = slide;
		})
		$('.markup-item--selector').click(function () {
			$(this).parent().siblings('.rotating-img-markup-item.active').removeClass('active');
			$(this).parent().toggleClass('active');
		})
		if (/rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
			$('#rotating-img-slider').on('change', function (e) {
				$('.rotating-img-markup-item.active').removeClass('active');
				$('.rotating-img-slide.active').removeClass('active');
				$('.rotating-img-title.active').removeClass('active');
				$('.rotating-img-titles').find("[data-slide='" + e.target.value + "']").addClass('active');
				$('.rotating-img-ins').find("[data-slide='" + e.target.value + "']").addClass('active');
			})
		} else {
			$('#rotating-img-slider').on('input', function (e) {
				$('.rotating-img-markup-item.active').removeClass('active');
				$('.rotating-img-slide.active').removeClass('active');
				$('.rotating-img-title.active').removeClass('active');
				$('.rotating-img-titles').find("[data-slide='" + e.target.value + "']").addClass('active');
				$('.rotating-img-ins').find("[data-slide='" + e.target.value + "']").addClass('active');
			})
		}
	}
	if ($('.section--rotating-img-row-new').length > 0) {
		$('.rotating-img-title').click(function (e) {
			if ($(this).hasClass('active')) {
				return true;
			}
			$('.rotating-img-slide .rotating-img-markup-item.active').removeClass('active');
			$('.rotating-img-title.active').removeClass('active');
			$(this).addClass('active');
			$('.rotating-img-slide.active').removeClass('active');
			let act_case = $(this).data('case');
			$('.rotating-img-markup-item.active').removeClass('active');
			$('.rotating-img-container').find("[data-case='" + act_case + "']").addClass('active');
			let act_slide = 0;
			$('.rotating-img-slide').each(function () {
				let cases = $(this).data('cases').split(' ');
				if (cases.includes(act_case.toString())) {
					$(this).addClass('active');
					act_slide = $(this).data('slide');
					$('#rotating-img-slider')[0].value = act_slide;
				}
			})
		})
		$('.markup-item--selector').click(function () {
			$(this).parent().siblings('.rotating-img-markup-item.active').removeClass('active');
			$(this).parent().toggleClass('active');
		})
		if (/rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
			$('#rotating-img-slider').on('change', function (e) {
				$('.rotating-img-markup-item.active').removeClass('active');
				$('.rotating-img-slide.active').removeClass('active');
				$('.rotating-img-title.active').removeClass('active');
				$('.rotating-img-titles').find("[data-slide='" + e.target.value + "']").addClass('active');
				$('.rotating-img-ins').find("[data-slide='" + e.target.value + "']").addClass('active');
			})
		} else {
			$('#rotating-img-slider').on('input', function (e) {
				$('.rotating-img-markup-item.active').removeClass('active');
				$('.rotating-img-slide.active').removeClass('active');
				$('.rotating-img-title.active').removeClass('active');
				$('.rotating-img-titles').find("[data-slide='" + e.target.value + "']").addClass('active');
				$('.rotating-img-ins').find("[data-slide='" + e.target.value + "']").addClass('active');
			})
		}
	}
})

// Interstitial
// $doc.ready(function () {
// 	$('a').click(function (e) {
// 		let whitelist = ['local.shockwave.com', 'local.shockwave', 'https://blog.shockwavemedical.com', 'swmedxds.wpengine.com', 'shockwavemedical.com', 'http://#', 'http:/#', 'swmedstage.wpengine.com'];
// 		for (let i = 0; i < whitelist.length; i++) {
// 			if ((e.target.href != undefined) || (e.target.href.indexOf(whitelist[i]) >= 0)) {
// 				return;
// 			}
// 			if (e.target.id === 'interstitial-link') {
// 				$.magnificPopup.close();
// 				e.preventDefault();
// 			}
// 		}
// 		e.preventDefault();
// 		let url = e.target.href;
// 		$.magnificPopup.open({
// 			items: {
// 				src: '    <div class="popup-form popup--interstitial">\n' +
// 					'        <div class="form form-popup" id="interstitial">\n' +
// 					'            <h2 class="popup-title popup-title--interstitial text-center">You are leaving shockwavemedical.com</h2>\n' +
// 					'            <p class="interstitial--body text-center">Please be aware that the external site policies may differ from our website terms and conditions and privacy policy. The next site will open in a new browser window.</p>\n' +
// 					'            <p class="interstitial--footer text-center">Note: Shockwave Medical is not responsible for any content on third party sites, nor does a link suggest endorsement of those sites and/or their content.</p>\n' +
// 					'            <a target="_blank" rel="noopener" href="' + url + '" class="btn btn--orange" id="interstitial-link">Continue</a>\n' +
// 					'        </div>\n' +
// 					'    </div>', // can be a HTML string, jQuery object, or CSS selector
// 				type: 'inline'
// 			}
// 		});
// 		$('#interstitial-link').click(function () {
// 			$.magnificPopup.close();
// 		})
// 	})
// })

// USAINTBTN
$doc.ready(function () {
	$('.usaintbtn--ctrl').on('click', function (e) {
		e.preventDefault();
		if ($(this).parents('.usaintbtn').find('.usaintbtn--int:visible').length > 0) {
			$(this).parents('.usaintbtn').find('.usaintbtn--int:visible').slideUp();
		} else {
			$(this).next('.usaintbtn--int[data-step=1]').slideToggle();
		}
	});
	if ($('.usaintbtn .btn').length > 0) {
		$('.usaintbtn .btn').each(function () {
			if ($(this).data('tgt') !== undefined) {
				$(this).on('click', function (e) {
					e.preventDefault();
					var data = $(this).data('tgt');
					$(this).parent('.usaintbtn--int').slideToggle(function () {
						$(this).parent('.usaintbtn').find('.usaintbtn--int[data-step=' + data + ']').slideToggle();
					});
				});
			}
		});
	}
});

// SmoothScroll
$doc.ready(function () {
	$('.local-scroll').click(function (e) {
		e.preventDefault();
		$.scrollTo('#ls-target', 750, {
			offset: -250,
			onAfter: function () {
				if ($('#video-tgt').length > 0) {
					$('#video-tgt')[0].play();
				}
				if ($('.iframe-target').length > 0) {
					var org = $('.iframe-target')[0].src;
					var newsrc = org + '?autoplay=1';
					$('.iframe-target').attr('src', newsrc);
				}
			}
		});
	});
	var hash = window.location.hash.replace('#', '');
	if (hash != '' && document.getElementById(hash) !== null) {
		$.scrollTo('#ls-target', 750, {
			offset: -250,
			onAfter: function () {
				if ($('#video-tgt').length > 0) {
					$('#video-tgt')[0].play();
				}
				if ($('.iframe-target').length > 0) {
					var org = $('.iframe-target')[0].src;
					var newsrc = org + '?autoplay=1';
					$('.iframe-target').attr('src', newsrc);
				}
			}
		});
	}

	 //Auto scroll to the anchor if hash is existed
	 setTimeout(function() {
		if (location.hash) {
		window.scrollTo(0, 0);
		let target = location.hash.replace('#', '')
		smoothScrollTo($('#'+target));
		}
	  }, 200);

	  function smoothScrollTo(target) {
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

		if (target.length) {
		  $('html,body').animate({
			scrollTop: target.offset().top
		  }, 800);
		}
	}

	$('.reimbursement-container--mobile').parents('a').css('width', '100%');

});//doc ready

// careers page grid animations
$('.icon-image').click(function () {
	if ($(this).find('.icon-description').hasClass('open')) {
		$(this).find('.icon-description').removeClass('open');
	} else {
		$(this).find('.icon-description').addClass('open');
	}


})
$('icon-description').click(function () {

	if ($(this).hasClass('open')) {
		$(this).removeClass('open');
	} else {
		$(this).addClass('open');
	}
})

//menu hover
$('.reimbursement-container').hover(function () {
	$('.menu-hover a:first-of-type()').css('color', 'white');
})
$('.menu-hover a:first-of-type()').hover(function () {
	$(this).css('color', '#323d47');
}, function () {
	$(this).css('color', 'white');
})

//three card popup
$(document).ready(function(){
	$('.three-card-popup').magnificPopup({

		type: 'iframe',
		iframe: {
			markup: '<div class="mfp-iframe-scaler ">' +
				'<div class="mfp-close">X</div>' +
				' <iframe class="mfp-iframe" muted playsinline autoplay width="560" height="315"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>' +
				'</div>'
		},
		mainClass: 'mfp-fade mfp-three-card-popup',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
		callbacks: {
			open: function () {

				$('body').addClass('noscroll');

			},
			close: function () {
				$('body').removeClass('noscroll');

			}
		},
	}); //popup script


	 //Auto open video if hash is existed
	 setTimeout(function() {
		if (window.location.hash) {
			let pathname = location.pathname;
			if(pathname.includes('clinicians/usa/peripheral/clinical-evidence/pad-iii')){
				let split = location.hash.split('?');
				let target = split[0].split('#');

				let anchorContent = target[1];
				console.log(anchorContent);

				if(anchorContent == 'pad3-video'){
				  $('.three-card-popup').magnificPopup('open');
				}
			}
		}
	}, 1);

})


/****
	 * ANIMATION VIDEO
	 * **/
// Get media - with autoplay disabled (audio or video)
let animation = $('#pad-animation');
let vid = animation[0];
let tolerancePixel = 20;

function checkMedia() {
	// Get current browser top and bottom
	let scrollTop = $(window).scrollTop() + tolerancePixel;
	let scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixel;
// console.log(animation)
	let yTopVideo = animation.offset().top;
	let yBottomVideo = animation.height() + yTopVideo;
	if (scrollTop < yBottomVideo && scrollBottom > yTopVideo) {
		vid.play();
	} else {
		vid.pause();
	}


}
if(vid !== undefined){

	$(window).on('scroll', checkMedia);
}



// Countdown
// $(document).ready(function(){
// 	const second = 1000,
// 	minute = second * 60,
// 	hour = minute * 60,
// 	day = hour * 24;
// 	let countDown = new Date('March 07, 2022 13:00:00 GMT').getTime(),
// 	x = setInterval(function() {
// 	let now = new Date().getTime(),

// 		distance = countDown - now;

// 		document.getElementById('modal–-m5__days').innerText = Math.floor(distance / (day)),
// 		document.getElementById('modal–-m5__hours').innerText = Math.floor((distance % (day)) / (hour)),
// 		document.getElementById('modal–-m5__minutes').innerText = Math.floor((distance % (hour)) / (minute)),
// 		document.getElementById('modal–-m5__seconds').innerText = Math.floor((distance % (minute)) / second);

// 	}, second)
// });


// // Twitter iframe injections
// $("iframeovigmp").on("load", function(e){
// 	let head = $('#iframeovigmp').contents().find("head");
// 	let css = '<style>body.wPostFull #controllerContent {height: auto !important;}</style>';
// 	$(head).append(css);
// });

// careers__row--jobs


$doc.ready(function () {
	// FAQ
	$('.faq__header').click(function() {
        $(".faq__body").not($(this).next()).not('.faq__body--ignore').slideUp(400);
        $(this).next().slideToggle(400);
        $(".faq--target").not($(this).closest(".faq--target")).removeClass("open-faq");
        $(this).closest(".faq--target").toggleClass("open-faq");
        setTimeout(function () {
            $("html, body").animate({
                scrollTop: $(".open-faq .faq__body").offset().top - 150
            }, "slow");
        }, 500);
	});
});

// Youtube Embed with Custom Thumbnail
var video = document.getElementsByClassName('video-responsive');
if(video) {
	$(".video-responsive iframe").attr('src', $(".video-responsive iframe").attr('src') + '?rel=0');
	$( ".video-responsive" ).click(function() {
		$(".video-thumbnail").hide();
		$(".video-responsive iframe").attr('src', $(".video-responsive iframe").attr('src') + '&autoplay=1');
	});
}

$doc.ready(function () {
	// values grid animations
	$('.sp-values-icon-image--img, .sp-values-icon-info').click(function () {
		if ($(this).parent().find('.sp-values-icon-description').hasClass('sp-values-open')) {
			$(this).parent().find('.sp-values-icon-description').removeClass('sp-values-open');
		} else {
			$(this).parent().find('.sp-values-icon-description').addClass('sp-values-open');
		}
	})
	$('.sp-values-icon-description--close').click(function () {
		if ($(this).parent().hasClass('sp-values-open')) {
			$(this).parent().removeClass('sp-values-open');
		} else {
			$(this).parent().addClass('sp-values-open');
		}
	})
});